import { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAppDispatch } from '@/store';
import { AppState } from '@/store';
import { filtersAdd } from '@features/partner/redux/partner.actions';
import FilterSidebar from '@components/tailwind/FilterSidebar';
import HoverableText from '@components/tailwind/HoverableText';
import { TPartnerProductCard } from '@types';

type Props = {
  rel?: string;
};

const CategoryList = ({ rel }: Props) => {
  const dispatch = useAppDispatch();

  const {
    filterOptions: { category },
    sidebarFilters: { categories },
  } = useSelector((state: AppState) => state.partner);

  const onCategoryClick = (id) => (e) => {
    e.preventDefault();

    dispatch(filtersAdd('category', id));
  };

  if (!categories || categories.length <= 0) return null;

  return (
    <FilterSidebar title='Category'>
      <ul className='tw-mb-0 tw-list-none tw-pl-0'>
        {categories.map((i) => (
          <li className='tw-mb-4 tw-block tw-transition tw-duration-300' key={i.category?.id}>
            <HoverableText
              active={i.category?.id === category}
              onClick={onCategoryClick(i.category?.id)}
              {...{ rel }}
              className='tw-text-sm tw-font-normal tw-text-body'>
              {i.category?.name} ({i.count})
            </HoverableText>
          </li>
        ))}
      </ul>
    </FilterSidebar>
  );
};

export default memo(CategoryList);
